import { ToastError } from '@/utils'

export default {
  data () {
    return {
      isInvalid: true,
      showErrors: false
    }
  },
  methods: {
    requestSave () {
      if (this.isInvalid) {
        this.showErrors = true
        ToastError(this.$gettext(`toast.validation.failed`))
      } else {
        this.save()
      }
    },
    saveAndDispatch (action) {
      return this.$store.dispatch(action)
      .then((data) => {
        let type = data._entityName.split('.').splice(-1)[0].toLowerCase()
        let id = data._id
        this.$router.push({
          name: 'anzeigen_einzeln',
          params: {
            resourceType: type,
            resourceId: id
          }
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/ValidateAndSave.js